import { useEffect, useState } from 'react';
import { useLocale } from '../../i18n/LocaleContext';
import { useAuth } from '../AuthContext';

/** Guests must pick a display name before playing — used on leaderboards. */
export function NameGate({ children }: { children: React.ReactNode }) {
  const { user, loading, ensureGuest, setUsername } = useAuth();
  const { t } = useLocale();
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    void ensureGuest();
  }, [ensureGuest]);

  if (loading || !user) {
    return (
      <section className="panel">
        <p className="muted">{t('loading')}</p>
      </section>
    );
  }

  if (user.username) return <>{children}</>;

  const save = async () => {
    setError(null);
    setSaving(true);
    try {
      await setUsername(name.trim());
      setName('');
    } catch (e) {
      setError(e instanceof Error ? e.message : t('nameSaveFail'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="panel name-gate">
      <h1>{t('nameGateTitle')}</h1>
      <p className="muted">{t('nameGateHint')}</p>
      <div className="field-row">
        <input
          autoFocus
          maxLength={16}
          placeholder={t('profileUsername')}
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') void save();
          }}
        />
        <button type="button" className="btn primary" disabled={saving || !name.trim()} onClick={() => void save()}>
          {saving ? t('loading') : t('profileSave')}
        </button>
      </div>
      {error ? <p className="error">{error}</p> : null}
      <p className="muted">{t('nameGateRules')}</p>
    </section>
  );
}
